import { AnswerBase } from './answer-base';

export class TextareaAnswer extends AnswerBase<string> {
    override controlType = 'textarea';

    constructor(options: {} = {}) {
        super(options);
    }
}
